import React from "react";
import { navigate } from "@reach/router";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ToolbarButton from "./button";

const NewInterestButton: React.FC<{currentListId: string}> = ({ currentListId }) => {

  const handleClick = () => {
    const listId = currentListId;
    navigate(`/dash/manager/interests/${listId}/new`);
  };
  return (
    <ToolbarButton
      className="NewInterestButton btn-table"
      onClick={handleClick}
      style={{
        boxShadow: "0 1px 2px 0 rgba(34,36,38,.07)",
      }}
    >
      <AddCircleIcon
        style={{
          fontSize: 19,
          margin: "8px 0px 0px 9px",
          color: "#B6B6B6",
        }}
      />
    </ToolbarButton>
  );
};

export default NewInterestButton;
